// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Pg_2_13_avatarContainer__Qqq5W","avatarWrap":"Pg_2_13_avatarWrap__1QtHi"};